import {
  Button,
  Dialog,
  Flex,
  ScrollArea,
} from '@radix-ui/themes'
import { useFetcher } from 'react-router'
import { VersionBlock } from '#app/components/ui/changelog-shared.js'
import { type ChangelogVersion } from '#app/data/changelog.server.ts'

interface ChangelogDialogProps {
  versions: ChangelogVersion[]
  open: boolean
  onOpenChange: (open: boolean) => void
  dismissUpdatesLastSeen?: boolean
}

export function ChangelogDialog({
  versions,
  open,
  onOpenChange,
  dismissUpdatesLastSeen = false,
}: ChangelogDialogProps) {
  const fetcher = useFetcher()

  function handleClose() {
    if (dismissUpdatesLastSeen) {
      fetcher.submit(null, {
        method: 'POST',
        action: '/api/changelog-dismiss',
      })
    }
    onOpenChange(false)
  }

  if (versions.length === 0) return null

  return (
    <Dialog.Root open={open} onOpenChange={o => !o && handleClose()}>
      <Dialog.Content maxWidth="560px">
        <Dialog.Title>Release notes</Dialog.Title>
        <Dialog.Description size="2" color="gray" mb="4">
          {dismissUpdatesLastSeen
            ? "Here's what's new since your last visit."
            : 'All release notes.'}
        </Dialog.Description>

        <ScrollArea style={{ maxHeight: '60vh' }}>
          <Flex direction="column" gap="4" pr="4">
            {versions.map(v => (
              <VersionBlock key={v.version} version={v} />
            ))}
          </Flex>
        </ScrollArea>

        <Flex justify="end" mt="4">
          <Button variant="soft" onClick={handleClose}>
            Close
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
